import React, { useEffect, useState } from 'react';
import { doc, setDoc } from "firebase/firestore";
import { db } from '../../../../firebase';
import PropertyForm from '../../../forms/property/property-form';
import StatesCities from "../../../../assets/json/states-and-districts.json";
import { useAuth } from '../../../../context/AuthContext';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';

function AddProperty({ addPropertyModalShow, handleAddPropertyModalClose }) {

  const { user, settings } = useAuth();
  const { bid } = user.claims;

  const [isLoading, setIsLoading] = useState(false);
  const [stateCities, setStateCities] = useState(null);
  const [propertyData, setPropertyData] = useState({
    name: '',
    number: '',
    locality: '',
    city: '',
    pincode: '',
    state: '',
    type: 'Building',
    totalArea: '',
    unitMeasure: 'sqft'
  });
  const [inputError, setInputError] = useState(null);

  function getStateCities(state) {
    const filteredCitiesByState = StatesCities && StatesCities.find(val => val.state === state).districts;

    if (filteredCitiesByState) {
      setStateCities(filteredCitiesByState);
    }
  }

  useEffect(() => {
    if (settings) {
      settings.forEach(doc => {
        if (doc.id === 'general') {
          setPropertyData((prevData) => {
            return {
              ...prevData,
              type: doc.propertyType
            }
          });
        }
      });
    }
  }, [settings]);

  async function postData(id, data) {
    setIsLoading(true);
    data = { addedOn: new Date(), updatedOn: new Date(), ...data };
    try {
      await setDoc(doc(db, "Businesses", bid, "Properties", id), data);
      handleAddPropertyModalClose();
      setIsLoading(false);
    } catch (error) {
      console.log('Adding Property Data [Error] : ', error);
      setIsLoading(false);
    }
  }

  function validateAndPostData() {
    const { name, locality, city, state } = propertyData;
    if (!name) {
      setInputError({ ...inputError, name: 'This field is required.' });
    } else if (!locality) {
      setInputError({ ...inputError, locality: 'This field is required.' });
    } else if (!state) {
      setInputError({ ...inputError, state: 'This field is required.' });
    } else if (!city) {
      setInputError({ ...inputError, city: 'This field is required.' });
    } else {
      let uuid = uuidv4();
      postData(uuid, propertyData);
    }
  }

  return (
    <Modal
      size='lg'
      show={addPropertyModalShow}
      onHide={handleAddPropertyModalClose}
      backdrop="static"
      keyboard={false}
      centered={true}
    >
      <div className='modal-header'>
        <h5 className='mb-0'>Add New Property</h5>
        <Button variant='none' className='btn-close px-3' onClick={handleAddPropertyModalClose} />
      </div>
      <div className='modal-body p-0'>
        <div className='px-4'>
          <PropertyForm
            propertyData={propertyData}
            setPropertyData={setPropertyData}
            stateCities={stateCities}
            getStateCities={getStateCities}
            inputError={inputError}
            setInputError={setInputError}
          />
        </div>
      </div>
      <div className='modal-footer px-3 align-items-center justify-content-between'>
        <Button
          variant="outline-danger"
          onClick={() => handleAddPropertyModalClose()}
          className='px-5 py-2'
        >
          Cancel
        </Button>
        {
          isLoading ?
            <Button
              disabled
              variant="primary"
              className='px-5 py-2 btn-width'
              onClick={() => null}
            >
              <Spinner />
            </Button>
            :
            <Button
              variant="primary"
              className='px-5 py-2 btn-width'
              onClick={() => validateAndPostData()}
            >
              Save
            </Button>
        }
      </div>
    </Modal>
  );
}

export default AddProperty;